import { createReducer } from 'reduxsauce';
import { PAYMENTS } from 'actions/Base';
import _ from 'lodash/fp';

export const INITIAL_STATE = {
  isLoading: false,
  authenticatedAccount: {},
  paymentReports: {},
  paymentEvents: {}
};

export const onCreateAccountRequest = (state) => ({ ...state, isLoading: true });
export const onCreateAccountFailure = (state) => ({ ...state, isLoading: false });
export const onCreateAccountSuccess = (state, { payload }) => {
  console.log('onCreateAccountSuccess', payload)
}

export const onGetPaymentReportsListRequest = (state, { params }) => ({ ...state, isLoading: true });
export const onGetPaymentReportsListFailure = (state) => ({ ...state, isLoading: false });
export const onGetPaymentReportsListSuccess = (state, { payload }) => {
  return ({
    ...state,
    isLoading: false,
    paymentReports: {
      ...state.paymentReports,
      [`HITCLUB-${payload.hitClubId}`] : payload.data
    }
  })
}

export const onGetPaymentEventsListRequest = (state, { params }) => ({ ...state, isLoading: true });
export const onGetPaymentEventsListFailure = (state) => ({ ...state, isLoading: false });
export const onGetPaymentEventsListSuccess = (state, { payload }) => {
  return ({
    ...state,
    isLoading: false,
    paymentEvents: {
      ...state.paymentEvents,
      [`HITCLUB-${payload.hitClubId}`] : payload.data
    }
  })
}


export const ACTION_HANDLERS = {
  [PAYMENTS.CREATE_ACCOUNT_REQUEST]: onCreateAccountRequest,
  [PAYMENTS.CREATE_ACCOUNT_FAILURE]: onCreateAccountFailure,
  [PAYMENTS.CREATE_ACCOUNT_SUCCESS]: onCreateAccountSuccess,

  [PAYMENTS.GET_PAYMENT_REPORTS_REQUEST]: onGetPaymentReportsListRequest,
  [PAYMENTS.GET_PAYMENT_REPORTS_FAILURE]: onGetPaymentReportsListFailure,
  [PAYMENTS.GET_PAYMENT_REPORTS_SUCCESS]: onGetPaymentReportsListSuccess,

  [PAYMENTS.GET_PAYMENT_REPORTS_DEBOUNCED_REQUEST]: onGetPaymentReportsListRequest,
  [PAYMENTS.GET_PAYMENT_REPORTS_DEBOUNCED_FAILURE]: onGetPaymentReportsListFailure,
  [PAYMENTS.GET_PAYMENT_REPORTS_DEBOUNCED_SUCCESS]: onGetPaymentReportsListSuccess,

  [PAYMENTS.GET_PAYMENT_EVENTS_REQUEST]: onGetPaymentEventsListRequest,
  [PAYMENTS.GET_PAYMENT_EVENTS_FAILURE]: onGetPaymentEventsListFailure,
  [PAYMENTS.GET_PAYMENT_EVENTS_SUCCESS]: onGetPaymentEventsListSuccess,

  [PAYMENTS.GET_PAYMENT_EVENTS_DEBOUNCED_REQUEST]: onGetPaymentEventsListRequest,
  [PAYMENTS.GET_PAYMENT_EVENTS_DEBOUNCED_FAILURE]: onGetPaymentEventsListFailure,
  [PAYMENTS.GET_PAYMENT_EVENTS_DEBOUNCED_SUCCESS]: onGetPaymentEventsListSuccess,
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);
